import { APPOINTMENT_TASKS_STATUS } from 'constants/AppointmentConstants';
import { BOOKING_STATUSES } from 'constants/LockerConstants';

export const isPreparationStatus = (status, bookingStatus) =>
  bookingStatus === BOOKING_STATUSES.FREE && status === APPOINTMENT_TASKS_STATUS.TO_START;

export const isUnpreparationStatus = (status, bookingStatus) =>
  bookingStatus === BOOKING_STATUSES.FREE && status === APPOINTMENT_TASKS_STATUS.PREPARED;

export const isVerificationStatus = bookingStatus => bookingStatus === BOOKING_STATUSES.USED;
